import { useMutation } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { TimelineAssignee } from 'types/timeline';

interface UseAssignUserProps {
    orgId: string;
    dealId: number;
    timelineId: number;
}

const assignUserToTimeline = async (
    orgId: string,
    dealId: number,
    timelineId: number,
    userCorrelationId: string,
): Promise<TimelineAssignee> => {
    const response = await axiosInstance.post<TimelineAssignee>(
        API_ENDPOINTS.TIMELINE_ASSIGNEES(orgId, dealId, timelineId),
        { userCorrelationId },
    );
    return response.data;
};

export const useAssignUser = ({ orgId, dealId, timelineId }: UseAssignUserProps) => useMutation({
    mutationFn: ({ userCorrelationId }: { userCorrelationId: string }) =>
        assignUserToTimeline(orgId, dealId, timelineId, userCorrelationId),
});
